import React, { useMemo } from 'react';
import { MessageStatus, InlineMessageStatus } from '@apps/registry/admin/components/CreditCardWidget/components/MessageStatus/MessageStatus';
import { useCreditCardSetupContext } from '@apps/registry/admin/components/CreditCardSetup/CreditCardSetUp.context';

export const KYCStatus: React.FC = () => {
  const { payoutAccountInfo, maxAttemptsReached } = useCreditCardSetupContext();
  const currentStatus: InlineMessageStatus = useMemo(() => {
    if (payoutAccountInfo?.status === 'pending' && maxAttemptsReached) {
      return 'warning';
    }

    return 'loading';
  }, [payoutAccountInfo, maxAttemptsReached]);

  return (
    <MessageStatus
      url={payoutAccountInfo?.onboardingUrl || undefined}
      isInline={true}
      messageStatus={currentStatus}
    />
  );
};
